export const ADD_PROJECT_PRODUCT_BY_URLS_MUTATION = `
    mutation AddProductsByUri($account_id: Int!, $uris: String!,  $project_id: Int!) {
        addProductsByUri(account_id: $account_id, uris: $uris, project_id: $project_id) {
            id
            name
            image_url
            custom_properties {
                key
                value
            }
            product_retailers {
                id
                sku
                url
                image_url
                retailer {
                    id
                    name
                }
            }
        }
    }
`;

export const ATTACH_PROJECT_PRODUCT_MUTATION = `
    mutation AttachProduct($product_id: Int!, $project_id: Int!) {
        attachProduct(product_id: $product_id, project_id: $project_id) {
            id
            name
            image_url
            custom_properties {
                key
                value
            }
            product_retailers {
                id
                sku
                url
                image_url
                retailer {
                    id
                    name
                }
            }
        }
    }
`;

export const REMOVE_PROJECT_PRODUCT_MUTATION = `
    mutation DetachProduct($product_id: Int!, $project_id: Int!) {
        detachProduct(product_id: $product_id, project_id: $project_id)
    }
`;
